// extracted by mini-css-extract-plugin
export default {"zoomModal":"R4-z","image":"S4-z","button":"T4-z","isOverlayShown":"U4-z"};